import { Tab, Tabs } from "@mui/material";
import { TabsProps } from "@mui/material/Tabs/Tabs";
import { useState } from "react";
import styled from "styled-components";
import { MdmTabPanel } from "./MdmTabPanel";

interface MdmTab {
  index: number;
  label: string;
  content: JSX.Element;
  disabled?: boolean;
}

interface MdmTabsProps extends TabsProps {
  tabs: MdmTab[];
}

export function MdmTabs({ tabs, ...props }: MdmTabsProps) {
  const [tabValue, setTabValue] = useState(0);

  return (
    <>
      <Tabs value={tabValue} onChange={(_, newTabValue) => setTabValue(newTabValue)} {...props}>
        {tabs.map((tab) => (
          <Tab key={tab.label} label={tab.label} disabled={tab.disabled} />
        ))}
      </Tabs>

      <StyledDivider />

      {tabs.map(
        (tab) =>
          tab && (
            <MdmTabPanel key={tab.label} value={tabValue} index={tab.index}>
              {tab.content}
            </MdmTabPanel>
          )
      )}
    </>
  );
}

const StyledDivider = styled.hr`
  height: 2px;
  margin: 0;
  opacity: 0.4;
`;
